import { render, staticRenderFns } from "./usulanDokumenreviu.vue?vue&type=template&id=e1401c28&"
import script from "./usulanDokumenreviu.vue?vue&type=script&lang=js&"
export * from "./usulanDokumenreviu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QItem,QItemSection,QInput,QBtn,QTooltip,QSeparator,QFab,QFabAction,QDialog,QEditor,QCardActions,QBtnGroup,QFile,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QItem,QItemSection,QInput,QBtn,QTooltip,QSeparator,QFab,QFabAction,QDialog,QEditor,QCardActions,QBtnGroup,QFile,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
